import React, { useEffect } from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/system';

import { useInView } from "react-intersection-observer";
import { motion, useAnimationControls } from 'framer-motion';
import Typewriter from './animation/TypeWriter';

const TransparentContainer = styled(Box)({
  backgroundColor: 'rgba(0, 0, 0, 0.75)',
  borderRadius: '2.5%',
});

export default function CoverBlock() {
  const controls = useAnimationControls();
  const [ref, inView, entry] = useInView({ threshold: 0.5 });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [controls, inView]);

  const variants = {
    visible: {
      y: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        delayChildren: 0.2,
        staggerChildren: 0.1,
      }
    },
    hidden: {
      y: entry,
      opacity: 0,
      scale: 0,
    },
  }

  return (
    <Box
      sx={{
        pt: 8,
        pb: 6,
        bgcolor: 'primary.dark',
        backgroundImage: 'url(/static/cover.webp)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <motion.div
        ref={ref}
        animate={controls}
        variants={variants}
      >
        <Container
          sx={{
            maxWidth: { xs: "100%", sm: "sm", md: "lg" },
          }}
        >
          <TransparentContainer>
            <Box
              sx={{
                maxWidth: { xs: "100%", sm: "sm", md: "lg" },
                paddingTop: { xs: 4, sm: 6, md: 16 },
                paddingLeft: { xs: 6, sm: 9, md: 24 },
                paddingRight: { xs: 6, sm: 9, md: 24 },
                paddingBottom: { xs: 4, sm: 6, md: 16 },
              }}
            >
              <Typography
                sx={{
                  typography: {
                    xs: 'h3',
                    sm: 'h2',
                    md: 'h1'
                  }
                }}
                align="center"
                color="customText.white"
              >
                Hi !
              </Typography>

              <Typography
                sx={{
                  typography: {
                    xs: 'h3',
                    sm: 'h2',
                    md: 'h1'
                  }
                }}
                align="center"
                gutterBottom
                color="customText.white"
              >
                I'm Peter Lee
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mt: 2,
                  mb: 4,
                }}
              >
                <Typewriter text="Full Stack Developer"></Typewriter>
              </Box>
            </Box>
          </TransparentContainer>
        </Container>
      </motion.div>
    </Box >
  )
}